import { render, staticRenderFns } from "./InstitutionLogo.vue?vue&type=template&id=3e293cba&"
import script from "./InstitutionLogo.vue?vue&type=script&lang=js&"
export * from "./InstitutionLogo.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
